import React from "react";
import { Box, Icon, type IconProps } from "@chakra-ui/react";

export function AgentsIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 40 40" fill="none" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M20.088 6.265c.762.005 1.61.237 2.277.848.705.647 1.03 1.56.97 2.538l-.207 3.395c-.1 1.65.845 2.847 2.521 3.127l11.813 1.969c.662.11 1.286.488 1.64 1.146.324.606.308 1.243.178 1.725a2.784 2.784 0 0 1-2.273 2.007l-12.728 1.906c-2.157.323-4.278 1.88-5.256 3.88l-1.671 3.418c-.814 1.665-2.46 2.526-3.96 2.526-.76 0-1.604-.222-2.274-.822-.709-.635-1.047-1.538-1.001-2.513l.17-3.646c.074-1.561-.793-2.695-2.317-3.032l-3.579-.79c-.952-.21-1.734-.771-2.161-1.619-.405-.8-.4-1.673-.204-2.405.388-1.448 1.642-2.811 3.456-3.17l4.002-.79c2.08-.411 4.056-1.93 4.987-3.833l1.632-3.339c.82-1.674 2.477-2.535 3.985-2.526ZM20 9.6c-.296.024-.696.226-.906.656l-1.633 3.338c-1.387 2.838-4.232 5.024-7.332 5.636l-4.002.791c-.468.093-.767.428-.868.708l3.428.759c3.107.686 5.075 3.258 4.927 6.437l-.165 3.491c.298-.024.7-.224.91-.653l1.672-3.42c1.453-2.97 4.5-5.221 7.754-5.709l7.568-1.134-6.253-1.042c-3.335-.556-5.503-3.239-5.296-6.615l.197-3.243Z"
      />
      <Box
        as="path"
        fill="currentColor"
        d="m28.11 26.546-1.671 3.418c-1.039 2.122-4.174 2.122-4.074 0l.097-2.116a.397.397 0 0 1 .138-.287c.614-.516 1.367-.867 2.134-.962l3.145-.388c.18-.023.311.17.231.335Zm.073-18.553c1.046-2.137 4.203-2.117 4.073.026l-.207 3.395c-.063 1.023.159 1.95.613 2.718.233.395-.167 1.243-.62 1.172l-4.253-.672c-1.122-.178-1.853-.994-1.891-2.077a.392.392 0 0 1 .072-.234c.216-.318.412-.647.58-.989l1.633-3.34Z"
        opacity=".4"
      />
    </Icon>
  );
}
